import momentJalaali from "moment-jalaali";
import {
  ADD_FORM,
  DELETE_INDEX,
  RESET_ACCOUNTING,
  RESET_APP_FORMS,
  RESET_FACTOR,
  RESET_FORM,
  RESET_FORM_STATE,
  RESET_INSTALLMENT,
  RESET_REMITTANCE,
  RESET_TRANSACTION,
  RESET_TRANSFER,
  SET_ACTION,
  SET_DELETE_QUEUE,
  SET_EDIT_ITEM,
  SET_INDEX,
  SET_PAGE,
  UNDO_DELETE_QUEUE,
  UPDATE_ACCOUNTING,
  UPDATE_FACTOR,
  UPDATE_FORM,
  UPDATE_FORM_STATUS,
  UPDATE_INSTALLMENT,
  UPDATE_REMITTANCE,
  UPDATE_TRANSACTION,
  UPDATE_TRANSFER,
} from "../../constants/formConstants";

const initialForm = [
  {
    index: 0,
    main: {},
    others: {},
  },
];

const initialState = {
  page: "",
  action: "filling",
  editItem: null,
  forms: initialForm,
  updateFlag: false,
  activeIndex: 0,
  deleteQueue: [],
  accounting: {},
  factor: {},
  transaction: {},
  remittance: {},
  transfer: {},
  installment: {},
};

const formReducer = (state = initialState, action) => {
  // state = {...initialState, ...state}
  if (!state.accounting) {
    state.accounting = {};
  }
  switch (action.type) {
    case SET_ACTION:
      return {
        ...state,
        action: action.action,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.page,
      };
    case SET_INDEX:
      return {
        ...state,
        activeIndex: action.index,
      };
    case SET_EDIT_ITEM:
      return {
        ...state,
        editItem: action.editItem,
      };
    case DELETE_INDEX:
      let newIndexAfterDelete = state.activeIndex;
      const newFormsAfterDelete = state.forms.filter((form) => {
        return form.index !== action.index;
      });
      if (state.activeIndex === action.index) {
        newIndexAfterDelete = newFormsAfterDelete[0].index;
      }
      return {
        ...state,
        action: "filling",
        activeIndex: newIndexAfterDelete,
        forms: newFormsAfterDelete,
      };
    case SET_DELETE_QUEUE:
      return {
        ...state,
        deleteQueue: [...state.deleteQueue, action.index],
      };
    case UNDO_DELETE_QUEUE:
      const newDeleteQueue = state.deleteQueue.filter((deleteIndex) => deleteIndex !== action.index);
      return {
        ...state,
        deleteQueue: newDeleteQueue,
      };
    case RESET_APP_FORMS:
      return initialState;
    case RESET_FORM:
      const emptyForm = [
        {
          index: 0,
          main: {},
          others: {},
        },
      ];
      return {
        ...state,
        forms: emptyForm ,
        page: action.page ?? state.page,
        updateFlag: !state.updateFlag,
        action: "filling",
        activeIndex: undefined,
        editItem: null,
        deleteQueue: [],
      };
    case ADD_FORM:
      const newIndex = state.forms[state.forms.length - 1].index + +1;
      return {
        ...state,
        activeIndex: newIndex,
        forms: [
          ...state.forms,
          {
            index: newIndex,
            main: {},
            others: {},
          },
        ],
      };
    case UPDATE_FORM:
      let tempForms = state.forms;
      const activeIndex = state.activeIndex ?? 0;
      const inputType = action.primary ? "main" : "others";
      if (tempForms.find((form) => form.index === activeIndex)) {
        tempForms.find((form) => form.index === activeIndex)[inputType][action.key] = action.value;
      }
      return {
        ...state,
        action: "filling",
        activeIndex,
        forms: tempForms,
        updateFlag: action.updateFlag ?? false,
      };
    case UPDATE_FORM_STATUS:
      const tempFormStatus = state.forms;
      if (tempFormStatus.find((form) => form.index === state.activeIndex)) {
        tempFormStatus.find((form) => form.index === state.activeIndex).status = action.status;
        tempFormStatus.find((form) => form.index === state.activeIndex).errors = action.errors;
      }
      return {
        ...state,
        forms: tempFormStatus,
      };
    case RESET_ACCOUNTING:
      return {
        ...state,
        accounting: {},
      };
    case UPDATE_ACCOUNTING:
      let accounting = state.accounting ?? {};
      accounting[action.key] = action.value;
      return {
        ...state,
        accounting,
      };
    case RESET_FACTOR:
      return {
        ...state,
        factor: {
          factorTab: state.factor.factorTab,
          factorCurrency: state.factor.factorCurrency,
          storeDate: momentJalaali(),
          paymentDate: momentJalaali(),
        },
      };
    case UPDATE_FACTOR:
      let factor = state.factor ?? {};
      factor[action.key] = action.value;
      return {
        ...state,
        factor,
      };
    case RESET_TRANSACTION:
      return {
        ...state,
        transaction: {},
      };
    case UPDATE_TRANSACTION:
      const transaction = state.transaction ?? {};
      transaction[action.key] = action.value;
      return {
        ...state,
        transaction,
      };
    case RESET_REMITTANCE:
      return {
        ...state,
        remittance: {},
      };
    case UPDATE_REMITTANCE:
      const remittance = { ...state.remittance } ?? {};
      if (action.key === "remittance") {
        return {
          ...state,
          remittance: action.value,
        };
      }
      if (action.value !== undefined) {
        remittance[action.key] = action.value;
      }
      return {
        ...state,
        remittance,
      };
    case RESET_TRANSFER:
      return {
        ...state,
        transfer: {},
      };
    case UPDATE_TRANSFER:
      const transfer = state.transfer ?? {};
      transfer[action.key] = action.value;
      return {
        ...state,
        transfer,
      };
    case RESET_INSTALLMENT:
      return {
        ...state,
        installment: {},
      };
    case UPDATE_INSTALLMENT:
      const installment = state.installment ?? {};
      installment[action.key] = action.value;
      return {
        ...state,
        installment,
      };
    case RESET_FORM_STATE:
      return initialState;
    default:
      return state;
  }
};

export default formReducer;
